if (!customElements.get('lr-purchase-controls')) {
  customElements.define('lr-purchase-controls', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      if (!this.info) return;
      this.required = JSON.parse(this.dataset.required || '[]');
      this.chosen = new Set(this.dataset.explicit === 'true' ? this.required : []);
      this.sticky = this.querySelector('.lr-mobile-purchase');
      this.isModal = Boolean(this.closest('quick-add-modal'));
      this.onChange = (event) => {
        const input = event.target;
        if (input.closest('variant-selects') && input.dataset.optionName) this.chosen.add(input.dataset.optionName);
        this.refresh();
      };
      this.onSubmit = (event) => {
        if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;
        if (this.missing().length) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.focusMissing();
        }
      };
      this.onClick = (event) => {
        const label = event.target.closest('variant-selects label');
        const input = label ? document.getElementById(label.htmlFor) : event.target.closest('variant-selects input');
        if (input?.dataset.optionName) {
          this.chosen.add(input.dataset.optionName);
          this.refresh();
        }
      };
      this.onScroll = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.refreshVisibility(); });
      };
      this.info.addEventListener('change', this.onChange, true);
      this.info.addEventListener('click', this.onClick, true);
      this.info.addEventListener('submit', this.onSubmit, true);
      this.querySelector('[data-sticky-purchase]')?.addEventListener('click', () => {
        if (this.missing().length) this.focusMissing();
        else this.button?.click();
      });
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this.info, {subtree:true, childList:true, attributes:true, attributeFilter:['disabled']});
      window.addEventListener('scroll', this.onScroll, {passive:true});
      window.addEventListener('resize', this.onScroll, {passive:true});
      this.refresh();
    }
    missing() { return this.required.filter(name => !this.chosen.has(name)); }
    focusMissing() {
      const name = this.missing()[0];
      const input = [...this.info.querySelectorAll('variant-selects input')].find(el => el.dataset.optionName === name && !el.classList.contains('disabled'));
      const field = input?.closest('fieldset');
      if (field) {
        field.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'center'});
        field.classList.add('lr-purchase-prompt');
        input.focus({preventScroll:true});
        setTimeout(() => field.classList.remove('lr-purchase-prompt'), 2000);
      }
    }
    refresh() {
      this.button = this.info.querySelector('.product-form__submit');
      if (!this.button) return;
      const missing = this.missing();
      const mainLabel = this.button.querySelector('span');
      const nextLabel = missing.length ? (missing[0].toLowerCase() === 'width' ? this.dataset.chooseWidth : this.dataset.chooseSize) : this.dataset.add;
      if (!this.button.disabled && mainLabel && mainLabel.textContent.trim() !== nextLabel) mainLabel.textContent = nextLabel;
      const stickyButton = this.querySelector('[data-sticky-purchase]');
      if (stickyButton) {
        const label = this.button.disabled ? mainLabel?.textContent.trim() : nextLabel;
        if (stickyButton.textContent !== label) stickyButton.textContent = label;
        if (stickyButton.disabled !== this.button.disabled) stickyButton.disabled = this.button.disabled;
      }
      const price = this.info.querySelector('[id^="price-"]');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      if (price && stickyPrice && stickyPrice.innerHTML !== price.innerHTML) stickyPrice.innerHTML = price.innerHTML;
      const selection = this.querySelector('[data-sticky-selection]');
      if (selection) {
        const text = missing.length ? this.dataset.selectionHelp : [...this.info.querySelectorAll('variant-selects input:checked')].map(input => `${input.dataset.optionName}: ${input.value}`).join(' · ');
        if (selection.textContent !== text) selection.textContent = text;
      }
      this.refreshVisibility();
    }
    refreshVisibility() {
      if (!this.sticky || !this.button) return;
      const footer = document.querySelector('footer');
      const show = !this.isModal && innerWidth < 750 && this.button.getBoundingClientRect().bottom < 0 && (!footer || footer.getBoundingClientRect().top > innerHeight);
      this.sticky.classList.toggle('is-visible',show);
      document.body.classList.toggle('lr-has-sticky-purchase',show);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.info?.removeEventListener('change',this.onChange,true);
      this.info?.removeEventListener('click',this.onClick,true);
      this.info?.removeEventListener('submit',this.onSubmit,true);
      window.removeEventListener('scroll',this.onScroll);
      window.removeEventListener('resize',this.onScroll);
      if (this.frame) cancelAnimationFrame(this.frame);
      document.body.classList.remove('lr-has-sticky-purchase');
    }
  });
}
